<nz-table
  #tableRef
  nzShowSizeChanger
  [nzData]="results"
  [nzLoading]="isLoading()"
  [nzFrontPagination]="false"
  [nzTotal]="total"
  [nzPageIndex]="pageIndex"
  [nzPageSize]="pageSize"
  (nzPageIndexChange)="onPageChange($event)"
  (nzPageSizeChange)="onPageSizeChange($event)"
  >
  <thead>
    <tr>
      <th>Name</th>
      <th>Nummer</th>
      <th>EAN</th>
      @for (store of stores; track store) {
        <th>{{ store.value }}</th>
      }
      <th>Gesamt</th>
    </tr>
  </thead>
  <tbody>
    @for (item of results; track item) {
      <tr>
        <td>{{ item.articleTitle }}</td>
        <td>{{ item.number }}</td>
        <td>{{ item.ean }}</td>
        @for (store of stores; track store) {
          <td>
            @if ((item | dateRangeSalesHistoryStoreItem:+store.id); as data) {
              @if (data.amount !== null) {
                <span class="white-space-no-wrap">
                  {{ data.amount | numberToCurrency }} / {{ data.count }}
                </span>
              } @else {
                -
              }
            }
          </td>
        }
        <td class="white-space-no-wrap">
          {{ item.totalAmount | numberToCurrency }} / {{ item.totalCount }}
        </td>
      </tr>
    }
  </tbody>
</nz-table>

@if (!isLoading() && results.length) {
  <div style="padding-right: 16px; margin-top: 16px; display: flex; gap: 32px; justify-content: flex-end">
    <nz-statistic [nzValue]="(totalAmount | numberToCurrency)" nzTitle="Gesamtbetrag" />
    <nz-statistic [nzValue]="(totalCount | number)" nzTitle="Gesamtzahl" />
  </div>
}
